import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotifierService } from 'angular-notifier';
import { BlockUIService } from 'ng-block-ui';
import { FileItem, FileUploader } from 'ng2-file-upload';
import { ajaxCall, ajaxCallReturnValue } from 'src/app/core/services/ajax-call.service';
import { DataFileUploadResult } from 'src/app/core/upload-result.model';
import { DataFileUploadInformation } from '../models/data-file-upload-information.model';

@Component({
  selector: 'app-upload-master',
  templateUrl: './upload-master.component.html',
  styles: [
  ]
})
export class UploadMasterComponent implements OnInit {
  @ViewChild(NgForm) masterFileForm!: NgForm;
  @Input() uploadInfo: DataFileUploadInformation;

  public uploader: FileUploader = new FileUploader({ autoUpload: true });
  submitAttempt: boolean = false;
  uploadResult: DataFileUploadResult = new DataFileUploadResult();

  constructor(private ajax: ajaxCall,
    private modal: NgbActiveModal,
    private notifier: NotifierService,
    private blockUI: BlockUIService) { }

  ngOnInit(): void {
    this.uploader.options.url = this.uploadInfo.isMaster ? '/File/MasterUpload' : '/File/FormularyUpload';

    this.uploader.onBeforeUploadItem = (item: FileItem) => {
      this.blockUI.start('ajaxCall');
    };

    this.uploader.onSuccessItem = (item: FileItem, response: string, status: number) => {
      const file: ajaxCallReturnValue<DataFileUploadResult> = JSON.parse(response);
      if (file.success) {
        this.uploadResult = file.results;
      } else {
        this.notifier.notify('error', file.message);
      }
    }

    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      this.blockUI.stop('ajaxCall');
    };
  }

  dismiss(): void {
    this.modal.dismiss();
  }

  save(): void {
    this.submitAttempt = true;
    if (this.masterFileForm.invalid) {
      return;
    }
    this.uploadInfo.uploadResult = this.uploadResult;
    this.ajax.MakeCall('/Vendor/SaveUpload', this.uploadInfo).then(() => {
      this.modal.close();
    }, () => { });
  }

}
